import cn from 'clsx';
import { PropsWithChildren } from 'react';

interface BasicPillProps extends PropsWithChildren {
  readonly extraClassName: string;
}

export function BasicPill({ extraClassName, children }: BasicPillProps) {
  return (
    <span
      className={cn(
        'rounded-full border text-s px-3 py-2 uppercase flex items-center gap-1',
        extraClassName,
      )}
    >
      {children}
    </span>
  );
}
